import { AxiosResponse } from "axios";
import { API } from "../index";
import { Buffer } from "buffer";
import { UserInfo } from "../type";


export const userService = {
  getUserInfo: async (): Promise<AxiosResponse<UserInfo>> => {
    return await API.get(`/accounts/user-info/`);
  },

  getUserById: async (userId: number, pathname?: string): Promise<AxiosResponse> => {
    const path = pathname ? `?path=${Buffer.from(pathname).toString('base64')}` : '';
    return await API.get(`/accounts/users/${userId}/${path}`);
  },

  updateUserInfo: async (userId: number, data: any): Promise<AxiosResponse> => {
    return await API.put(`/accounts/update-user/${userId}/`, data);
  },

  updateUserPassword: async (password: string, phone_num?: string): Promise<AxiosResponse> => {
    return await API.post(`/accounts/set-user-password/`, { password, ...(phone_num && { phone_num }) });
  },

  getCancelableUsers: async (): Promise<AxiosResponse> => {
    return await API.get(`/sites/cancelable-user-find/`);
  },

  getKakaoChannels: async (): Promise<AxiosResponse> => {
    return await API.get(`/api/kakao/channels/`);
  },

  // Generic users list with filters (mirrors useUsers hook)
  getUsersList: async (params: any): Promise<AxiosResponse> => {
    return await API.get(`/accounts/users-crm`, { params });
  }
};